import {makeStyles} from '@mui/styles'

const useStyles = makeStyles(({palette, fontSizes, spacing, breakpoints}) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'minmax(200px, 280px) minmax(0, 1fr)',
    gap: spacing(6),
    alignItems: 'start',
    [breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: spacing(4),
    },
  },
  hasBackground: {
    background: palette.background.greyLight,
    padding: spacing(6),
    borderRadius: '80px 20px',
    boxShadow: '5px 5px 12px 0 rgb(51 51 51 / 20%)',
    [breakpoints.down('sm')]: {
      padding: spacing(4),
    },
  },
  leftSide: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    minWidth: 0,
    gap: spacing(4),
    '& > img': {
      width: '100%',
      maxWidth: 220,
      objectFit: 'contain',
    },
    [breakpoints.down('sm')]: {
      width: '100%',
      padding: 0,
      gap: spacing(3),
    },
  },
  rightSide: {
    width: '100%',
    minWidth: 0,
    [breakpoints.down('sm')]: {
      width: '100%',
      padding: 0,
    },
  },
  nameAndStatusContainer: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) minmax(220px, 300px)',
    gap: spacing(3),
    alignItems: 'flex-start',
    [breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: spacing(2),
    },
  },
  partnershipStatusContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    gap: spacing(1),
    width: '100%',
    minWidth: 0,
    [breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
    },
  },
  partnershipStatusImage: {
    display: 'block',
    width: '100%',
    maxWidth: 240,
    objectFit: 'contain',
    [breakpoints.down('sm')]: {
      marginBottom: spacing(1),
    },
  },
  partnershipStatusText: {
    margin: 0,
    fontFamily: 'CamptonMedium',
    fontSize: fontSizes.description,
    lineHeight: 1.45,
    textAlign: 'left',
    color: palette.text.primary,
  },
  partnershipStatusTooltipIcon: {
    marginTop: spacing(0.5),
    fontSize: 16,
    flexShrink: 0,
  },
  buttonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  title: {
    margin: 0,
    fontSize: fontSizes.subTitle,
    fontFamily: 'CamptonMedium',
    lineHeight: 1.15,
    [breakpoints.down('sm')]: {
      marginTop: spacing(1),
    },
  },
  description: {
    marginTop: spacing(2.5),
    maxWidth: 880,
    fontFamily: 'CamptonLight',
    fontSize: fontSizes.description,
    color: palette.text.primary,
    lineHeight: 1.55,
    '& p': {
      marginTop: 0,
      marginBottom: spacing(1.5),
    },
  },
  awardsList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: spacing(1.5),
    marginTop: spacing(3),
  },
  awards: {
    margin: 0,
    fontFamily: 'CamptonMedium',
    fontSize: fontSizes.description,
    whiteSpace: 'break-spaces',
    padding: '2px 5px 0 5px',
    borderRadius: 5,
    width: 'fit-content',
  },
  award0: {
    color: palette.tags.departments.color,
    backgroundColor: palette.tags.departments.backgroundColor,
  },
  award1: {
    color: palette.tertiary.main,
    backgroundColor: palette.tags.partners.backgroundColor,
  },
  award2: {
    color: palette.secondary.main,
    backgroundColor: palette.tags.industries.backgroundColor,
  },
  numbersGrid: {
    display: 'flex',
    justifyContent: 'space-between',
    textAlign: 'center',
    gap: spacing(3),
    marginTop: spacing(4),
    '&>div': {
      width: '100%',
      maxWidth: 220,
    },
    [breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: spacing(2),
      '&>div': {
        width: '100%',
        maxWidth: 'unset',
      },
    },
  },
  kpiItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(0.5),
  },
  numbers: {
    color: palette.text.primary,
    fontSize: fontSizes.subTitle,
    marginBottom: 0,
    fontFamily: 'CamptonMedium',
    fontWeight: 500,
  },
  kpiDescription: {
    margin: 0,
    fontFamily: 'CamptonLight',
    fontSize: fontSizes.description,
    color: palette.text.primary,
    lineHeight: 1.45,
  },
}))

export default useStyles
